import GuestAddressingIcon from 'assets/images/invitations/guest-addressing.svg';
import {
  ALL_PAPER_SHAPES,
  BASE_PAPER_SHAPES,
  ALL_PAPER_TYPES,
  BASE_PAPER_TYPES,
  ALL_FOIL_COLORS,
  ALL_STAMPED_FOIL_COLORS,
} from 'cards/constants/CardLevelOptions';

import defaultSavethedate from 'cards/components/ProjectPaperJourneyModule/CardTypeWidget/assets/savethedate.jpeg';
import defaultInvitation from 'cards/components/ProjectPaperJourneyModule/CardTypeWidget/assets/invitation.jpeg';
import defaultPlacecard from 'cards/components/ProjectPaperJourneyModule/CardTypeWidget/assets/placecard.jpeg';
import defaultMenu from 'cards/components/ProjectPaperJourneyModule/CardTypeWidget/assets/menu.jpeg';
import defaultProgram from 'cards/components/ProjectPaperJourneyModule/CardTypeWidget/assets/program.jpeg';
import defaultThankyou from 'cards/components/ProjectPaperJourneyModule/CardTypeWidget/assets/thankyou.jpeg';

import FeatureFlags from 'util/featureFlags';
import { BASE_URL } from './Cards';

export const CARD_TYPES = {
  invitation: 'INVITATION',
  invitationEnvelope: 'INVITATION_ENVELOPE',
  std: 'SAVE_THE_DATE',
  dstd: 'DIGITAL_SAVE_THE_DATE',
  ctd: 'CHANGE_THE_DATE',
  thankyou: 'THANK_YOU',
  menu: 'MENU',
  program: 'PROGRAM',
  place: 'PLACE',
  holiday: 'HOLIDAY',
  enclosure: 'ENCLOSURE',
  rsvp: 'RSVP',
  rsvpEnvelope: 'RSVP_ENVELOPE',
  envelope: 'ENVELOPE',
  matchingSuites: 'MATCHING_SUITES',
};

export const CARD_TYPES_WITH_ADDITIONAL_SHAPES = [
  CARD_TYPES.invitation,
  CARD_TYPES.std,
  CARD_TYPES.menu,
  CARD_TYPES.program,
  CARD_TYPES.holiday,
];
export const TYPES_WITHOUT_SILHOUETTE_OPTIONS = [CARD_TYPES.ctd, CARD_TYPES.place];

export const CARD_PLP_LINKS = {
  [CARD_TYPES.std]: {
    text: 'Save The Dates',
    path: `${BASE_URL}/save-the-date/shop`,
  },
  [CARD_TYPES.ctd]: {
    text: 'Change The Dates',
    path: `${BASE_URL}/change-the-date/shop`,
  },
  [CARD_TYPES.invitation]: {
    text: 'Invitations',
    path: `${BASE_URL}/invitations/shop`,
  },
  [CARD_TYPES.thankyou]: {
    text: 'Thank You Cards',
    path: `${BASE_URL}/thank-you-cards/shop`,
  },
  [CARD_TYPES.menu]: {
    text: 'Menus',
    path: `${BASE_URL}/menus/shop`,
  },
  [CARD_TYPES.program]: {
    text: 'Programs',
    path: `${BASE_URL}/programs/shop`,
  },
  [CARD_TYPES.place]: {
    text: 'Place Cards',
    path: `${BASE_URL}/place-cards/shop`,
  },
  DETAILS: {
    text: 'Enclosures Cards',
    path: `${BASE_URL}/enclosures/shop`,
  },
  [CARD_TYPES.holiday]: {
    text: 'Holiday Cards',
    path: `${BASE_URL}/holiday-cards/shop`,
  },
};

export const CARD_TYPES_WITH_INFO_BANNER = [
  CARD_TYPES.std,
  CARD_TYPES.ctd,
  CARD_TYPES.invitation,
  CARD_TYPES.enclosure,
  CARD_TYPES.place,
  CARD_TYPES.thankyou,
  CARD_TYPES.holiday,
];

export const CARD_TYPES_WITH_PROOF = [
  CARD_TYPES.invitation,
  CARD_TYPES.std,
  CARD_TYPES.menu,
  CARD_TYPES.program,
  CARD_TYPES.enclosure,
  CARD_TYPES.thankyou,
  CARD_TYPES.holiday,
  CARD_TYPES.place,
];

export const CARD_TYPES_WITH_SAMPLES = [CARD_TYPES.std, CARD_TYPES.invitation];
export const CARD_TYPES_WITH_RSVP = [CARD_TYPES.std, CARD_TYPES.invitation];
export const CARD_TYPES_WITH_FREE_CTD = [CARD_TYPES.std, CARD_TYPES.invitation];
export const CARD_TYPES_WITH_FREE_ENVELOPES = [
  CARD_TYPES.invitation,
  CARD_TYPES.std,
  CARD_TYPES.ctd,
  CARD_TYPES.thankyou,
  CARD_TYPES.holiday,
  CARD_TYPES.rsvp,
];
export const CARD_TYPES_WITH_FOIL_ENVELOPES = [
  CARD_TYPES.std,
  CARD_TYPES.invitation,
  CARD_TYPES.ctd,
];
export const CARD_TYPES_WITH_QR_CODES = [CARD_TYPES.std, CARD_TYPES.invitation];

export const AVAILABLE_PAPER_OPTIONS_BY_CARD_TYPE = {
  ADMIN: {
    THANK_YOU: {
      size: ['folded-petite', 'petite', 'postcard'],
      'foil-color': ALL_FOIL_COLORS,
      'paper-type': ALL_PAPER_TYPES,
    },
    HOLIDAY: {
      size: ['folded-petite', '5x7', 'petite', 'postcard'],
      'foil-color': ALL_FOIL_COLORS,
      'paper-type': ALL_PAPER_TYPES,
      silhouette: BASE_PAPER_SHAPES,
    },
    MENU: {
      size: ['menu-4x8', 'menu-5x7'],
      'foil-color': ALL_FOIL_COLORS,
      'paper-type': ALL_PAPER_TYPES,
      silhouette: BASE_PAPER_SHAPES,
    },
  },
  INVITATION: {
    'foil-color': ALL_FOIL_COLORS,
    'paper-type': ALL_PAPER_TYPES,
    silhouette: FeatureFlags.get('newPaperShapes') ? ALL_PAPER_SHAPES : BASE_PAPER_SHAPES,
  },
  SAVE_THE_DATE: {
    size: ['petite', '5x7', 'postcard'],
    'foil-color': ALL_FOIL_COLORS,
    'paper-type': ALL_PAPER_TYPES,
    silhouette: FeatureFlags.get('newPaperShapes') ? ALL_PAPER_SHAPES : BASE_PAPER_SHAPES,
  },
  CHANGE_THE_DATE: {
    size: ['petite', 'postcard'],
    'foil-color': null,
    'paper-type': BASE_PAPER_TYPES,
    silhouette: null,
  },
  THANK_YOU: {
    size: ['folded-petite', 'petite', 'postcard'],
    'foil-color': ALL_FOIL_COLORS,
    'paper-type': ALL_PAPER_TYPES,
  },
  MENU: {
    size: ['menu-4x8', 'menu-5x7'],
    'foil-color': ALL_FOIL_COLORS,
    'paper-type': ALL_PAPER_TYPES,
    silhouette: FeatureFlags.get('newPaperShapes') ? ALL_PAPER_SHAPES : BASE_PAPER_SHAPES,
  },
  PROGRAM: {
    'foil-color': ALL_FOIL_COLORS,
    'paper-type': ALL_PAPER_TYPES,
    silhouette: FeatureFlags.get('newPaperShapes') ? ALL_PAPER_SHAPES : BASE_PAPER_SHAPES,
  },
  PLACE: {
    'paper-type': ['smooth', 'eggshell', 'pearlized', 'linen', 'felt'],
  },
  HOLIDAY: {
    size: ['folded-petite', '5x7', 'petite', 'postcard'],
    'foil-color': ALL_FOIL_COLORS,
    'paper-type': ALL_PAPER_TYPES,
    silhouette: FeatureFlags.get('newPaperShapes') ? ALL_PAPER_SHAPES : BASE_PAPER_SHAPES,
  },
  ENCLOSURE: {
    'foil-color': ALL_FOIL_COLORS,
    'paper-type': ALL_PAPER_TYPES,
    silhouette: BASE_PAPER_SHAPES,
  },
};

export const AVAILABLE_PAPER_OPTIONS_BY_STAMPED_CARD_TYPE = {
  ADMIN: {
    THANK_YOU: {
      size: ['folded-petite', 'petite', 'postcard'],
      'foil-color': ALL_STAMPED_FOIL_COLORS,
      'paper-type': ALL_PAPER_TYPES,
    },
    HOLIDAY: {
      size: ['folded-petite', '5x7', 'petite', 'postcard'],
      'foil-color': ALL_STAMPED_FOIL_COLORS,
      'paper-type': ALL_PAPER_TYPES,
      silhouette: BASE_PAPER_SHAPES,
    },
    MENU: {
      size: ['menu-4x8', 'menu-5x7'],
      'foil-color': ALL_STAMPED_FOIL_COLORS,
      'paper-type': ALL_PAPER_TYPES,
      silhouette: BASE_PAPER_SHAPES,
    },
  },
  INVITATION: {
    'foil-color': ALL_STAMPED_FOIL_COLORS,
    'paper-type': ALL_PAPER_TYPES,
    silhouette: FeatureFlags.get('newPaperShapes') ? ALL_PAPER_SHAPES : BASE_PAPER_SHAPES,
  },
  SAVE_THE_DATE: {
    size: ['petite', '5x7', 'postcard'],
    'foil-color': ALL_STAMPED_FOIL_COLORS,
    'paper-type': ALL_PAPER_TYPES,
    silhouette: FeatureFlags.get('newPaperShapes') ? ALL_PAPER_SHAPES : BASE_PAPER_SHAPES,
  },
  CHANGE_THE_DATE: {
    size: ['petite', 'postcard'],
    'foil-color': null,
    'paper-type': BASE_PAPER_TYPES,
    silhouette: null,
  },
  THANK_YOU: {
    size: ['folded-petite', 'petite', 'postcard'],
    'foil-color': ALL_STAMPED_FOIL_COLORS,
    'paper-type': ALL_PAPER_TYPES,
  },
  MENU: {
    size: ['menu-4x8', 'menu-5x7'],
    'foil-color': ALL_STAMPED_FOIL_COLORS,
    'paper-type': ALL_PAPER_TYPES,
    silhouette: BASE_PAPER_SHAPES,
  },
  PROGRAM: {
    'foil-color': ALL_STAMPED_FOIL_COLORS,
    'paper-type': ALL_PAPER_TYPES,
    silhouette: BASE_PAPER_SHAPES,
  },
  PLACE: {
    'paper-type': ['smooth', 'eggshell', 'pearlized', 'linen', 'felt'],
  },
  HOLIDAY: {
    size: ['folded-petite', '5x7', 'petite', 'postcard'],
    'foil-color': ALL_STAMPED_FOIL_COLORS,
    'paper-type': ALL_PAPER_TYPES,
    silhouette: BASE_PAPER_SHAPES,
  },
  ENCLOSURE: {
    'foil-color': ALL_STAMPED_FOIL_COLORS,
    'paper-type': ALL_PAPER_TYPES,
    silhouette: BASE_PAPER_SHAPES,
  },
};

export const AVAILABLE_MAGNET_OPTIONS_BY_CARD_TYPE = {
  SAVE_THE_DATE: {
    size: ['magnet', '5x7', 'postcard'],
    finish: ['glossy', 'matte'],
    silhouette: ['square', 'rounded'],
  },
  HOLIDAY: {
    size: ['magnet', '5x7', 'postcard'],
    finish: ['glossy', 'matte'],
    silhouette: ['square', 'rounded'],
  },
};

export const AVAILABLE_TYPE_OPTIONS_BY_CARD_TYPE = {
  INVITATION: ['paper'],
  SAVE_THE_DATE: ['paper', 'magnet'],
  CHANGE_THE_DATE: ['paper'],
  THANK_YOU: ['paper'],
  MENU: ['paper'],
  PROGRAM: ['paper'],
  HOLIDAY: ['paper', 'magnet'],
  ENCLOSURE: ['paper'],
};

// for Customization:
export const ORDERED_CUSTOMIZATION_TYPES = [
  'INVITATION',
  'RSVP',
  'SAVE_THE_DATE',
  'CHANGE_THE_DATE',
  'DETAILS',
  'ENCLOSURE',
  'MENU',
  'PROGRAM',
  'PLACE',
  'THANK_YOU',
  'ENVELOPE',
  'INVITATION_ENVELOPE',
  'RSVP_ENVELOPE',
  'HOLIDAY',
];

export const PRIMARY_CUSTOMIZATION_TYPES = [
  'INVITATION',
  'SAVE_THE_DATE',
  'DIGITAL_SAVE_THE_DATE',
  'CHANGE_THE_DATE',
  'ENCLOSURE',
  'MENU',
  'PROGRAM',
  'PLACE',
  'THANK_YOU',
  'HOLIDAY',
];

export const ENABLED_PROOF_ORDER_CARD_TYPES = [
  CARD_TYPES.invitation,
  CARD_TYPES.std,
  CARD_TYPES.ctd,
  CARD_TYPES.menu,
  CARD_TYPES.program,
  CARD_TYPES.enclosure,
  CARD_TYPES.thankyou,
  CARD_TYPES.holiday,
  CARD_TYPES.place,
];

export const PROJECT_COPY_MAP = {
  [CARD_TYPES.invitation]: {
    title: 'Wedding Invitation',
  },
  [CARD_TYPES.std]: {
    title: 'Save The Date',
  },
  [CARD_TYPES.ctd]: {
    title: 'Change The Date',
  },
  [CARD_TYPES.thankyou]: {
    title: 'Thank You Card',
  },
  [CARD_TYPES.menu]: {
    title: 'Menu',
  },
  [CARD_TYPES.enclosure]: {
    title: 'Enclosure Card',
  },
  [CARD_TYPES.program]: {
    title: 'Program Card',
  },
  [CARD_TYPES.place]: {
    title: 'Place Cards',
  },
  [CARD_TYPES.holiday]: {
    title: 'Holiday Card',
  },
};

export const HERO_COPY = {
  [CARD_TYPES.invitation]: {
    header: 'Wedding Invitations',
    description: 'Invite guests with the perfect stationery that matches your wedding style.',
  },
  [CARD_TYPES.std]: {
    header: 'Save The Dates',
    subheader: '',
    description:
      'Set the tone for your wedding and choose a beautiful design that shows off your style.',
  },
  [CARD_TYPES.ctd]: {
    header: 'Change The Dates',
    subheader: '',
    description:
      'Set the tone for your wedding and choose a beautiful design that shows off your style.',
  },
  DETAILS: {
    header: 'Enclosure Cards',
    subheader: '',
    description: 'Complete your invitation suite and share all your wedding details with guests.',
  },
  [CARD_TYPES.menu]: {
    header: 'Wedding Menus',
    subheader: '',
    description: 'Show guests your meal options on gorgeous cards that match your suite.',
  },
  [CARD_TYPES.program]: {
    header: 'Wedding Programs',
    subheader: '',
    description: 'Choose a design to highlight your unique ceremony details, fun facts, and more.',
  },
  [CARD_TYPES.thankyou]: {
    header: 'Thank You Cards',
    subheader: '',
    description:
      'Write your thoughtful notes on a special design. You can even add a custom wedding photo.',
  },
  [CARD_TYPES.holiday]: {
    header: 'Holiday Cards',
    subheader: '',
    description:
      'Send your season’s greetings with a unique design your friends and family will love.',
  },
  [CARD_TYPES.place]: {
    header: ' Place Cards',
    subheader: '',
    description: 'Help your guests find their reception table with these elegant designs.',
  },
};

export const PLP_MODULE_GROUP_TAGS = {
  DETAILS: 'invites-plp-enclosure',
  ENCLOSURE: 'invites-plp-enclosure',
  HOLIDAY: 'invites-plp-holiday',
  INVITATION: 'invites-plp-invitation',
  MENU: 'invites-plp-menu',
  PLACE: 'invites-plp-placecard',
  PROGRAM: 'invites-plp-program',
  SAVE_THE_DATE: 'invites-plp-savethedate',
  // TODO DSTD
  // DIGITAL_SAVE_THE_DATE: 'invites-plp-digitalsavethedate',
  CHANGE_THE_DATE: 'invites-plp-changethedate',
  THANK_YOU: 'invites-plp-thankyou',
  MATCHING_SUITES: 'invites-plp-matching-suites',
};

export const PDP_MODULE_GROUP_TAGS = {
  DETAILS: 'invites-pdp-enclosure',
  ENCLOSURE: 'invites-pdp-enclosure',
  HOLIDAY: 'invites-pdp-holiday',
  INVITATION: 'invites-pdp-invitation',
  MENU: 'invites-pdp-menu',
  PLACE: 'invites-pdp-placecard',
  PROGRAM: 'invites-pdp-program',
  SAVE_THE_DATE: 'invites-pdp-savethedate',
  // TODO DSTD
  // DIGITAL_SAVE_THE_DATE: 'invites-plp-digitalsavethedate',
  CHANGE_THE_DATE: 'invites-pdp-changethedate',
  THANK_YOU: 'invites-pdp-thankyou',
};

export const ROUTES_PLP_LEAD_CARD = {
  invitations: {
    leadCardType: 'INVITATION',
  },
  'save-the-date': {
    leadCardType: 'SAVE_THE_DATE',
  },
  // TODO DSTD
  // 'digital-save-the-date': {
  //   leadCardType: 'DIGITAL_SAVE_THE_DATE',
  // },
  'change-the-date': {
    leadCardType: 'CHANGE_THE_DATE',
  },
  'thank-you-cards': {
    leadCardType: 'THANK_YOU',
  },
  menus: {
    leadCardType: 'MENU',
  },
  enclosures: {
    leadCardType: 'DETAILS',
  },
  programs: {
    leadCardType: 'PROGRAM',
  },
  'place-cards': {
    leadCardType: 'PLACE',
  },
  'holiday-cards': {
    leadCardType: 'HOLIDAY',
  },
};

export const PLP_EVENTS_AND_TITLES = {
  invitations: {
    activeCardEvent: 'INVITATION',
    pageTitle: 'Wedding Invitations | Customizable Templates & Designs - Zola',
    metaDescription:
      'Discover affordable wedding invitations that will leave your guests breathless. Explore beautiful designs & choose an invite that sets the tone for your big day.',
    metaKeywords:
      'Wedding invites,Wedding invitations,wedding invitation templates,Wedding invitation cards,Sample wedding invitations,Wedding invitation design,Wedding envelopes',
    canonical: `https://www.zola.com/wedding-planning/invitations/shop`,
  },
  'thank-you-cards': {
    activeCardEvent: 'THANK_YOU',
    pageTitle: 'Thank You Cards to Match Your Save The Dates, Invitations, and Wedding Website',
    metaDescription:
      'Find wedding thank you cards that will charm & delight your guests. Choose from dozens of beautiful designs to match your wedding theme and order in minutes.',
    metaKeywords: 'Wedding thank you cards,Custom thank you cards,Wedding thank you',
    canonical: `https://www.zola.com/wedding-planning/thank-you-cards/shop`,
  },
  menus: {
    activeCardEvent: 'MENU',
    pageTitle: 'Affordable Menus for your Wedding Reception | Hundreds of Templates & Samples',
    metaDescription:
      'Create a beautiful dining experience with the perfect wedding menu. Choose from dozens of elegant and charming designs and styles to match any wedding theme.',
    metaKeywords: 'Wedding menu,wedding menu cards,menu cards,wedding reception food menu',
    canonical: `https://www.zola.com/wedding-planning/menus/shop`,
  },
  programs: {
    activeCardEvent: 'PROGRAM',
    pageTitle: 'Affordable Wedding Programs | Hundreds of Templates & Samples',
    metaDescription:
      'Get the perfect program for your wedding day. Choose from dozens of charming designs to match your wedding theme and style & order with a few clicks.',
    metaKeywords:
      'Wedding programs,Wedding programs template,Ceremony program,Ceremony program template',
    canonical: `https://www.zola.com/wedding-planning/programs/shop`,
  },
  enclosures: {
    activeCardEvent: 'DETAILS',
    pageTitle: 'Affordable Enclosure Cards | Hundreds of Templates & Samples',
    metaDescription:
      'Get beautiful & elegant enclosure cards for your wedding. Choose from dozens of alluring designs that match your wedding theme & order with a few clicks.',
    canonical: `https://www.zola.com/wedding-planning/enclosures/shop`,
  },
  'place-cards': {
    activeCardEvent: 'PLACE',
    pageTitle: 'Affordable Place Cards | Hundreds of Templates & Samples',
  },
  'save-the-date': {
    activeCardEvent: 'SAVE_THE_DATE',
    pageTitle: 'Save The Date Cards & Wedding Postcards: Free Shipping - Zola',
    metaDescription:
      'Find save the date cards and postcards for your wedding in minutes. Choose from beautiful designs and imagery that set the tone for your special day.',
    metaKeywords:
      'save the date,Save the date cards,save the date magnets,Save the date wedding,Save the date invitations',
    canonical: `https://www.zola.com/wedding-planning/save-the-date/shop`,
  },
  'digital-save-the-date': {
    activeCardEvent: 'SAVE_THE_DATE',
    pageTitle: 'Free Digital Save the Dates for Your Wedding - Zola',
    metaDescription:
      "Spread the word about your wedding with digital save the date cards. Customize a beautiful design in minutes. The best part? They're free.",
    metaKeywords:
      'save the date,Save the date cards,save the date magnets,Save the date wedding,Save the date invitations',
    canonical: `https://www.zola.com/wedding-planning/digital/save-the-date/shop`,
  },
  'change-the-date': {
    activeCardEvent: 'CHANGE_THE_DATE',
    pageTitle: 'Change The Date Cards & Wedding Postponement Cards - Zola',
    metaDescription:
      'Need to postpone or reschedule your big day? Update guests with a change the date wedding card. Get free shipping, guest addressing, envelopes, and more.',
    canonical: `https://www.zola.com/wedding-planning/change-the-date/shop`,
  },
  'holiday-cards': {
    activeCardEvent: 'HOLIDAY',
    pageTitle: 'Affordable Holiday Cards | Unique Templates & Designs',
    canonical: `https://www.zola.com/wedding-planning/holiday-cards/shop`,
  },
};

export const SETTINGS_BY_CARD_TYPE = {
  MATCHING_SUITES: {
    type: 'MATCHING_SUITES',
    urlSlug: 'suites',
    label: 'suites',
    hasFoil: true,
    hasLetterpress: true,
    hasMotifs: true,
    hasShapes: false,
    hasMagnet: false,
    hasMultipleOrientations: false,
    hasThirdPartyDesigns: false,
    hasCustomPhoto: true,
    hasNoCustomPhoto: true,
    isVowRenewal: false,
    isLead: true,
    showPdpFreeAddressingModule: false,
    freeAddressingText: null,
    freeAddressingImage: null,
    showPdpCtdBanner: false,
    showPdpCovidBanner: false,
    showReviewStepCtdBanner: false,
  },
  [CARD_TYPES.invitation]: {
    type: CARD_TYPES.invitation,
    urlSlug: 'invitations',
    label: 'Invitations',
    hasFoil: true,
    hasLetterpress: true,
    hasMotifs: true,
    hasShapes: true,
    hasMagnet: false,
    hasMultipleOrientations: true,
    hasThirdPartyDesigns: true,
    hasCustomPhoto: true,
    hasNoCustomPhoto: true,
    isVowRenewal: true,
    isLead: true,
    showPdpFreeAddressingModule: false,
    freeAddressingText: null,
    freeAddressingImage: null,
    showPdpCtdBanner: true,
    showPdpCovidBanner: false,
    showReviewStepCtdBanner: true,
  },
  [CARD_TYPES.std]: {
    type: CARD_TYPES.std,
    urlSlug: 'save-the-date',
    label: 'Save The Dates',
    hasFoil: true,
    hasLetterpress: true,
    hasMotifs: true,
    hasShapes: true,
    hasMagnet: true,
    hasMultipleOrientations: true,
    hasThirdPartyDesigns: true,
    hasCustomPhoto: true,
    hasNoCustomPhoto: true,
    isVowRenewal: true,
    isLead: true,
    showPdpFreeAddressingModule: false,
    freeAddressingText: null,
    freeAddressingImage: null,
    showPdpCtdBanner: true,
    showPdpCovidBanner: false,
    showReviewStepCtdBanner: true,
  },
  // TODO DSTD
  [CARD_TYPES.dstd]: {
    type: CARD_TYPES.dstd,
    urlSlug: 'digital-save-the-date',
    label: 'Digital Save The Dates',
    hasFoil: false,
    hasLetterpress: false,
    hasMotifs: true,
    hasShapes: false,
    hasMagnet: false,
    hasMultipleOrientations: true,
    hasThirdPartyDesigns: true,
    hasCustomPhoto: true,
    hasNoCustomPhoto: true,
    isVowRenewal: true,
    isLead: true,
    showPdpFreeAddressingModule: false,
    freeAddressingText: null,
    freeAddressingImage: null,
    showPdpCtdBanner: true,
    showPdpCovidBanner: false,
    showReviewStepCtdBanner: true,
  },
  [CARD_TYPES.ctd]: {
    type: CARD_TYPES.ctd,
    urlSlug: 'change-the-date',
    label: 'Change The Dates',
    hasFoil: false,
    hasLetterpress: true,
    hasMotifs: false,
    hasShapes: false,
    hasMagnet: false,
    hasMultipleOrientations: true,
    hasThirdPartyDesigns: false,
    hasCustomPhoto: true,
    hasNoCustomPhoto: true,
    isVowRenewal: false,
    isLead: true,
    showPdpFreeAddressingModule: false,
    freeAddressingText: null,
    freeAddressingImage: null,
    showPdpCtdBanner: false,
    showPdpCovidBanner: true,
    showReviewStepCtdBanner: false,
  },
  [CARD_TYPES.thankyou]: {
    type: CARD_TYPES.thankyou,
    urlSlug: 'thank-you-cards',
    label: 'Thank You Cards',
    hasFoil: true,
    hasLetterpress: true,
    hasMotifs: true,
    hasShapes: false,
    hasMagnet: false,
    hasMultipleOrientations: true,
    hasThirdPartyDesigns: true,
    hasCustomPhoto: true,
    hasNoCustomPhoto: true,
    isVowRenewal: false,
    isLead: true,
    showPdpFreeAddressingModule: true,
    freeAddressingText: 'Enjoy FREE Guest Addressing & Envelopes',
    freeAddressingImage: GuestAddressingIcon,
    showPdpCtdBanner: false,
    showPdpCovidBanner: false,
    showReviewStepCtdBanner: false,
  },
  [CARD_TYPES.menu]: {
    type: CARD_TYPES.menu,
    urlSlug: 'menus',
    label: 'Menus',
    hasFoil: true,
    hasLetterpress: true,
    hasMotifs: true,
    hasShapes: false,
    hasMagnet: false,
    hasMultipleOrientations: false,
    hasThirdPartyDesigns: true,
    hasCustomPhoto: true,
    hasNoCustomPhoto: false,
    isVowRenewal: false,
    isLead: true,
    showPdpFreeAddressingModule: null,
    freeAddressingText: null,
    freeAddressingImage: null,
    showPdpCtdBanner: false,
    showPdpCovidBanner: false,
    showReviewStepCtdBanner: false,
  },
  [CARD_TYPES.program]: {
    type: CARD_TYPES.program,
    urlSlug: 'programs',
    label: 'Programs',
    hasFoil: true,
    hasLetterpress: true,
    hasMotifs: true,
    hasShapes: false,
    hasMagnet: false,
    hasMultipleOrientations: false,
    hasThirdPartyDesigns: true,
    hasCustomPhoto: true,
    hasNoCustomPhoto: false,
    isVowRenewal: false,
    isLead: true,
    showPdpFreeAddressingModule: null,
    freeAddressingText: null,
    freeAddressingImage: null,
    showPdpCtdBanner: false,
    showPdpCovidBanner: false,
    showReviewStepCtdBanner: false,
  },
  [CARD_TYPES.place]: {
    type: CARD_TYPES.place,
    urlSlug: 'place-cards',
    label: 'Place Cards',
    hasFoil: false,
    hasLetterpress: false,
    hasMotifs: true,
    hasShapes: false,
    hasMagnet: false,
    hasMultipleOrientations: false,
    hasThirdPartyDesigns: true,
    hasCustomPhoto: false,
    hasNoCustomPhoto: false,
    isVowRenewal: false,
    isLead: true,
    showPdpFreeAddressingModule: true,
    freeAddressingText: 'Enjoy FREE printing on Place Cards!',
    freeAddressingImage: GuestAddressingIcon,
    showPdpCtdBanner: false,
    showPdpCovidBanner: false,
    showReviewStepCtdBanner: false,
  },
  DETAILS: {
    type: 'DETAILS',
    urlSlug: 'enclosures',
    label: 'Enclosures',
    hasFoil: true,
    hasLetterpress: true,
    hasMotifs: true,
    hasShapes: false,
    hasMagnet: false,
    hasMultipleOrientations: true,
    hasThirdPartyDesigns: true,
    hasCustomPhoto: true,
    hasNoCustomPhoto: false,
    isVowRenewal: false,
    isLead: true,
    showPdpFreeAddressingModule: null,
    freeAddressingText: null,
    freeAddressingImage: null,
    showPdpCtdBanner: false,
    showPdpCovidBanner: false,
    showReviewStepCtdBanner: false,
  },
  [CARD_TYPES.enclosure]: {
    type: CARD_TYPES.enclosure,
    urlSlug: 'enclosures',
    label: 'Enclosures',
    hasFoil: true,
    hasLetterpress: true,
    hasMotifs: true,
    hasShapes: false,
    hasMagnet: false,
    hasMultipleOrientations: true,
    hasThirdPartyDesigns: true,
    hasCustomPhoto: true,
    hasNoCustomPhoto: false,
    isVowRenewal: false,
    isLead: true,
    showPdpFreeAddressingModule: null,
    freeAddressingText: null,
    freeAddressingImage: null,
    showPdpCtdBanner: false,
    showPdpCovidBanner: false,
    showReviewStepCtdBanner: false,
  },
  [CARD_TYPES.rsvp]: {
    type: CARD_TYPES.rsvp,
    urlSlug: null, // secondary card type, no slug.
    label: 'RSVP',
    hasFoil: true,
    hasLetterpress: true,
    hasMotifs: false,
    hasShapes: false,
    hasMagnet: false,
    hasMultipleOrientations: true,
    hasThirdPartyDesigns: false,
    hasCustomPhoto: true,
    hasNoCustomPhoto: true,
    isVowRenewal: false,
    isLead: false,
    showPdpFreeAddressingModule: null,
    freeAddressingText: null,
    freeAddressingImage: null,
    showPdpCtdBanner: null,
    showPdpCovidBanner: null,
    showReviewStepCtdBanner: null,
  },
  ENVELOPE: {
    type: 'ENVELOPE',
    urlSlug: null, // secondary card type, no slug.
    label: 'Envelope',
    hasFoil: false, // Not used for now
    hasLetterpress: false,
    hasMotifs: false,
    hasShapes: false,
    hasMagnet: false,
    hasMultipleOrientations: false,
    hasThirdPartyDesigns: false,
    hasCustomPhoto: false,
    hasNoCustomPhoto: false,
    isVowRenewal: false,
    isLead: false,
    showPdpFreeAddressingModule: null,
    freeAddressingText: null,
    freeAddressingImage: null,
    showPdpCtdBanner: null,
    showPdpCovidBanner: null,
    showReviewStepCtdBanner: null,
    hiddenPlpFilters: null, // secondary card type no PLP
  },
  [CARD_TYPES.holiday]: {
    type: CARD_TYPES.holiday,
    urlSlug: 'holiday-cards',
    label: 'Holiday Cards',
    hasFoil: true,
    hasLetterpress: false,
    hasMotifs: true,
    hasShapes: false,
    hasMagnet: false,
    hasMultipleOrientations: false,
    hasThirdPartyDesigns: true,
    hasCustomPhoto: true,
    hasNoCustomPhoto: true,
    isVowRenewal: false,
    isLead: true,
    showPdpFreeAddressingModule: true,
    freeAddressingText: 'Enjoy FREE Guest Addressing & Envelopes',
    freeAddressingImage: GuestAddressingIcon,
    showPdpCtdBanner: false,
    showPdpCovidBanner: false,
    showReviewStepCtdBanner: false,
  },
};

export const CARD_TYPES_BEFORE_THE_DAY = [CARD_TYPES.std, CARD_TYPES.invitation];

export const CARD_TYPES_ON_THE_DAY = [CARD_TYPES.place, CARD_TYPES.menu, CARD_TYPES.program];

export const CARD_TYPES_AFTER_THE_DAY = [CARD_TYPES.thankyou];

export const CARD_TYPES_JOURNEY_DATA = {
  [CARD_TYPES.std]: {
    title: 'Save the Dates',
    text: 'Order 6 months out',
    momentSubtractParameters: [6, 'M'],
    plpUrl: 'save-the-date',
    defaultImage: defaultSavethedate,
  },
  [CARD_TYPES.invitation]: {
    title: 'Invitations',
    text: 'Order 3–6 months out',
    plpUrl: 'invitations',
    momentSubtractParameters: [3, 'M'],
    defaultImage: defaultInvitation,
  },
  [CARD_TYPES.place]: {
    title: 'Place Cards',
    text: 'Order 3–4 weeks out',
    momentSubtractParameters: [4, 'w'],
    plpUrl: 'place-cards',
    defaultImage: defaultPlacecard,
  },
  [CARD_TYPES.menu]: {
    title: 'Menus',
    text: 'Order 3–4 weeks out',
    momentSubtractParameters: [4, 'w'],
    plpUrl: 'menus',
    defaultImage: defaultMenu,
  },
  [CARD_TYPES.program]: {
    title: 'Programs',
    text: 'Order 3–4 weeks out',
    momentSubtractParameters: [4, 'w'],
    plpUrl: 'programs',
    defaultImage: defaultProgram,
  },
  [CARD_TYPES.thankyou]: {
    title: 'Thank You Cards',
    text: 'Send within 3–4 months',
    momentSubtractParameters: [3, 'M'],
    plpUrl: 'thank-you-cards',
    defaultImage: defaultThankyou,
  },
};

export const CUSTOMIZATION_TYPES_MAP = new Map([
  ['DETAILS', 'Enclosure Card'],
  ['ENCLOSURE', 'Enclosure Card'],
  ['ENVELOPE', 'Envelope'],
  ['HOLIDAY', 'Holiday'],
  ['INVITATION', 'Invitation'],
  ['MENU', 'Menu'],
  ['PLACE', 'Place Card'],
  ['PROGRAM', 'Program'],
  ['SAVE_THE_DATE', 'Save the Date'],
  ['CHANGE_THE_DATE', 'Change the Date'],
  ['THANK_YOU', 'Thank You'],
  ['RSVP', 'RSVP'],
]);
